/**
 * Collection Lazy Loading Handler
 * Handles lazy loading of products in collection grids
 * Re-initializes after filtering/sorting
 */

(function() {
  'use strict';
  
  console.log('[Collection Lazy Load] Script loaded');
  
  // Store active scroll handlers to clean them up
  var activeScrollHandlers = [];
  
  /**
   * Initialize lazy loading for a section
   */
  function initLazyLoadForSection(sectionId) {
    console.log('[Collection Lazy Load] Initializing for section:', sectionId);
    
    var loadButton = document.getElementById('load-more-' + sectionId);
    var productGrid = document.getElementById('product-grid');
    var template = document.getElementById('remaining-products-' + sectionId);
    
    if (!loadButton || !productGrid || !template) {
      console.log('[Collection Lazy Load] Missing elements for section:', sectionId, {
        loadButton: !!loadButton,
        productGrid: !!productGrid,
        template: !!template
      });
      return false;
    }
    
    // Check if already initialized
    if (loadButton.dataset.lazyLoadInitialized === 'true') {
      console.log('[Collection Lazy Load] Already initialized for section:', sectionId);
      return true;
    }
    
    console.log('[Collection Lazy Load] Setting up event handlers for section:', sectionId);
    
    // Get settings from data attributes
    var itemsPerRow = parseInt(loadButton.dataset.itemsPerRow) || 4;
    var rowsPerLoad = parseInt(loadButton.dataset.rowsPerLoad) || 2;
    var autoLoad = loadButton.dataset.autoLoad === 'true';
    
    // Click handler for load more button
    var clickHandler = function(e) {
      e.preventDefault();
      console.log('[Collection Lazy Load] Load button clicked');
      
      var content = template.content;
      if (!content.firstElementChild) {
        console.log('[Collection Lazy Load] No more products to load');
        loadButton.parentNode.style.display = 'none';
        return;
      }
      
      var itemsToLoad = itemsPerRow * rowsPerLoad;
      var count = 0;
      
      console.log('[Collection Lazy Load] Loading up to', itemsToLoad, 'items');
      
      var fragment = document.createDocumentFragment();
      while (count < itemsToLoad && content.firstElementChild) {
        fragment.appendChild(content.firstElementChild);
        count++;
      }
      
      productGrid.appendChild(fragment);
      console.log('[Collection Lazy Load] Loaded', count, 'items');
      
      if (!content.firstElementChild) {
        console.log('[Collection Lazy Load] All products loaded, hiding button');
        loadButton.parentNode.style.display = 'none';
        
        // Remove scroll handlers
        cleanupScrollHandlers();
      }
    };
    
    loadButton.addEventListener('click', clickHandler);
    
    // Touch event for mobile
    var touchHandler = function(e) {
      e.preventDefault();
      loadButton.click();
    };
    loadButton.addEventListener('touchend', touchHandler);
    
    // Auto-load on scroll if enabled
    if (autoLoad) {
      console.log('[Collection Lazy Load] Auto-load on scroll enabled');
      
      var scrollHandler = function() {
        var content = template.content;
        if (!content.firstElementChild) {
          console.log('[Collection Lazy Load] No more products, removing scroll handler');
          cleanupScrollHandlers();
          return;
        }
        
        var rect = loadButton.getBoundingClientRect();
        if (rect.top < window.innerHeight + 300) {
          console.log('[Collection Lazy Load] Button in view, auto-loading');
          loadButton.click();
        }
      };
      
      // Store handlers for cleanup
      activeScrollHandlers.push({
        handler: scrollHandler,
        sectionId: sectionId
      });
      
      window.addEventListener('scroll', scrollHandler, { passive: true });
      document.addEventListener('scroll', scrollHandler, { passive: true });
    }
    
    // Mark as initialized
    loadButton.dataset.lazyLoadInitialized = 'true';
    
    console.log('[Collection Lazy Load] Successfully initialized for section:', sectionId);
    return true;
  }
  
  /**
   * Clean up scroll handlers
   */
  function cleanupScrollHandlers() {
    console.log('[Collection Lazy Load] Cleaning up scroll handlers');
    activeScrollHandlers.forEach(function(item) {
      window.removeEventListener('scroll', item.handler);
      document.removeEventListener('scroll', item.handler);
    });
    activeScrollHandlers = [];
  }
  
  /**
   * Find and initialize all lazy load sections on the page
   */
  function initAllLazyLoadSections() {
    console.log('[Collection Lazy Load] Searching for lazy load sections');
    
    // Clean up old handlers first
    cleanupScrollHandlers();
    
    // Find all load-more buttons
    var loadButtons = document.querySelectorAll('[id^="load-more-"]');
    console.log('[Collection Lazy Load] Found', loadButtons.length, 'load-more buttons');
    
    loadButtons.forEach(function(button) {
      // Extract section ID from button ID (format: load-more-SECTION_ID)
      var buttonId = button.id;
      var sectionId = buttonId.replace('load-more-', '');
      
      // Reset initialization flag to allow re-initialization
      button.dataset.lazyLoadInitialized = 'false';
      
      initLazyLoadForSection(sectionId);
    });
  }
  
  /**
   * Initialize on DOM ready
   */
  function init() {
    console.log('[Collection Lazy Load] Initializing on DOM ready');
    initAllLazyLoadSections();
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize after a short delay on window load (backup)
  window.addEventListener('load', function() {
    setTimeout(initAllLazyLoadSections, 100);
  });
  
  // Listen for content changes (when filters are applied)
  // The Filterable component replaces content in #facets-filterable
  var observeContentChanges = function() {
    var filterableEl = document.getElementById('facets-filterable');
    if (!filterableEl) {
      console.log('[Collection Lazy Load] No filterable element found, will retry');
      return;
    }
    
    console.log('[Collection Lazy Load] Setting up MutationObserver for content changes');
    
    var observer = new MutationObserver(function(mutations) {
      var shouldReinit = false;
      
      mutations.forEach(function(mutation) {
        // Check if product grid or load-more button was added/modified
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if added node contains load-more button or is the results div
              if (node.id === 'facets-results' || 
                  node.querySelector && node.querySelector('[id^="load-more-"]')) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      
      if (shouldReinit) {
        console.log('[Collection Lazy Load] Content changed, re-initializing...');
        // Give the DOM a moment to settle after Alpine.js processes
        setTimeout(initAllLazyLoadSections, 500);
      }
    });
    
    observer.observe(filterableEl, {
      childList: true,
      subtree: true
    });
    
    console.log('[Collection Lazy Load] MutationObserver active');
  };
  
  // Set up observer when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeContentChanges);
  } else {
    observeContentChanges();
  }
  
  // Also listen for the custom event dispatched by the theme
  document.addEventListener('shapes:section:willmutate', function() {
    console.log('[Collection Lazy Load] Section will mutate, preparing to re-initialize');
  });
  
})();

